import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import AssignedTable from "./AssignedTable";
import { MentorQueuesData } from "../../types";
import { loadAssignedMentors, beginSession } from "../../redux/actions/guideStreamActions";
import Loading from "../../../Shared/loading";
import { SessionStub } from "../../../Shared/GeneratedTypes";
import useInterval from "../../../Shared/useInterval";

const mapState = ({ assignedMentors, localizations, apiCallsInProgress, userInfo }: MentorQueuesData) => ({
    assignedMentors,
    localizations: localizations!,
    apiCallsInProgress,
    culture: userInfo.cultureInfo,
});

const mapDispatch = {
    loadAssignedMentors,
    beginSession,
};
const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;
type PropTypes = PropsFromRedux & {};

function AssignedPage({
    assignedMentors,
    loadAssignedMentors,
    localizations,
    beginSession,
    apiCallsInProgress,
    culture,
}: PropTypes) {
    useEffect(() => {
        if (!assignedMentors || assignedMentors.length === 0) {
            loadAssignedMentors();
        }
    }, []);

    const [secondsUntilRefresh, updateSecondsUntilRefresh] = useState(30);

    useInterval(() => {
        if (secondsUntilRefresh === 0) {
            loadAssignedMentors();
            updateSecondsUntilRefresh(30);
        } else {
            updateSecondsUntilRefresh(secondsUntilRefresh - 1);
        }
    }, 1000);

    const refreshNow = () => {
        loadAssignedMentors();
        updateSecondsUntilRefresh(30);
    };

    function selectMentor(session: SessionStub) {
        beginSession(session.customerId, session.id!);
    }

    return (
        <>
            {apiCallsInProgress > 0 ? (
                <>
                    <Loading message={localizations.loadingMentors} />
                </>
            ) : (
                <AssignedTable
                    refreshNow={refreshNow}
                    refreshTimer={secondsUntilRefresh}
                    assignedSessions={assignedMentors}
                    localizations={localizations}
                    setActive={selectMentor}
                    cultureCode={culture}
                />
            )}
        </>
    );
}

export default connector(AssignedPage);
